<template>
  <ItemContainer :title="'随机抽题'">
    <div class="flex items-center">
      <span class="text-medium font-normal leading-22 text-theme-black-850 mr-6">
        随机抽题
        <el-tooltip class="item" content="加入抽题条件的题目，默认随机打乱顺序；未加入的题目，则保留原题顺序" placement="right">
          <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer"></i>
        </el-tooltip>
      </span>
      <el-switch :value="numFlag" @change="handlerNumFlag"></el-switch>
    </div>
    <div v-show="numFlag" class="random-setting">
      <div class="random-question-items" v-for="(item,index) in randomExtractionQuestions" :key="index">
        <span>从题目</span>
        <el-select popper-class="cursom-overflow" @change="(val)=>changeBeginOptions(val,index)" class="w-330" v-model="item.beginQuestionId" placeholder="请选择">
          <el-option
            v-for="it in optionsList[index].beginOptions"
            :key="it.value"
            :disabled="it.disabled"
            :label="it.label"
            :value="it.value">
              <span class="option-overflow" style="
                float: left;
                max-width: 186px;
                padding-left: 12px;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                "
              >{{ it.label }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ it.type }}</span>
          </el-option>
        </el-select>
        <span>到题目</span>
        <el-select @change="(val)=>changeEndOptions(val,index)" class="w-330" v-model="item.endQuestionId" placeholder="请选择">
          <el-option
            v-for="it in optionsList[index].endOptions.filter((it,filterIdx)=> filterIdx>=item.beginIndex)"
            :key="it.value"
            :disabled="it.disabled"
            :label="it.label"
            :value="it.value">
            <span 
              style="
                float: left;
                max-width: 186px;
                padding-left: 12px;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
            >{{ it.label }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ it.type }}</span>
          </el-option>
        </el-select>
        <span>中随机抽取</span>
        <el-input-number
          style="width:66px"
          controls-position="right"
          placeholder=""
          v-model.number="item.questionNumber"
          autocomplete="off"
          :min="1"
          :max="item.endIndex - item.beginIndex + 1"
          @change="val => currentInputNumber(val)"
          :precision="0"
        />
        <span>道题目</span>
        <i class="iconfont btn-style" 
          @click="handleSettlement('add',index)"
          v-if="index === randomExtractionQuestions.length-1"
        >&#xe68c;</i>
        <i :class="index !== randomExtractionQuestions.length-1 ? 'iconfont btn-style' : 'iconfont btn-style ml-8' "
          @click="handleSettlement('remove',index)"
          v-if="randomExtractionQuestions.length>1"
          >&#xe68a;</i
        >
      </div>
      <div class="tips-style">
        <i class="iconfont icon-jingshishuoming"></i>
        <span>问题组、描述、分页均不可参与随机抽题。</span>
      </div>
      <div class="submit-btn">
        <el-button :disabled="saveDisable" type="primary" @click="handleSubmit">保存</el-button>
      </div>
    </div>
  </ItemContainer>
</template>

<script>
import ItemContainer from '@/components/base/ItemContainer.vue'
import GlobalConfig from '@/global/config.js'
import { getSurveyById } from '@/api/survey'
import { surveyInfo as getSurveyInfo } from '@/api/wenjuan/wjquestion'
import { saveSurveySetting } from '@/api/wenjuan/publish'
import { getQuotaList } from '@/api/quota2'
import { typeMapping } from '@dygc/question'
import { ResultType } from '@/question/logic2/types'
export default {
  name: 'RandomQuestion',
  components: { ItemContainer},
  props: {},
  data() {
    return {
      numFlag:false,
      catchOptions:[],
      logics:[],// 是否配置了逻辑
      quotaStatus:false,// 是否配置了样本配额
      saveDisable: false, // 是否禁用保存按钮
      optionsList:[{
        beginOptions:[],
        endOptions:[]
      }],
      randomExtractionQuestions:[
        {
          questionNumber:1,
          beginQuestionId:'',
          endQuestionId:'',
          beginIndex:0,
          endIndex: 0,
        }
      ],

    }
  },
  watch:{
    randomExtractionQuestions:{
      handler(valueData){
        const watchRandomQuestions = valueData;
        const cloneOptionsList = JSON.parse(JSON.stringify(this.optionsList));
        let saveDisable = false;
        watchRandomQuestions.forEach((it,i,arr)=> {
          if(it.beginQuestionId === '' || it.endQuestionId === '' || it.questionNumber === undefined){
            saveDisable = true;
          }
          cloneOptionsList.forEach((itOpList,iOpList) => {
            if(iOpList === i){
              itOpList.beginOptions.forEach((itOpts,iOpts)=>{
                if(i === 0){
                  itOpts.disabled = iOpts > it.endIndex ? true :false;
                }else if(i > 0){
                  let disabled = false;
                  if(iOpts < arr[i - 1].endIndex + 1 || iOpts > it.endIndex){
                    disabled = true;
                  }
                  itOpts.disabled = disabled;
                }
              })
              itOpList.endOptions.forEach((itOpts,iOpts)=>{
                if( i >= 0 && i !== arr.length - 1){
                  let disabled = false;
                  if(iOpts < it.beginIndex || iOpts >= arr[i + 1].beginIndex){
                    disabled = true;
                  }
                  itOpts.disabled = disabled;
                }else if( i === arr.length - 1){
                  itOpts.disabled = iOpts < it.beginIndex ? true :false;
                }
              })
            }
          })
        })
        this.optionsList = cloneOptionsList
        this.saveDisable = saveDisable;
      },
      deep:true
    }
  },
  methods: {
    getLogicIsAllScreen(){
      return this.logics.every(logic=>{
        return logic.resultType === ResultType.screen
      })
    },
    handlerNumFlag(val){
      if(val === false){
        this.$confirm('关闭随机抽题设置，您之前的设置将自动清除。确认关闭该设置吗？', '确认关闭随机抽题设置', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          saveSurveySetting({
            id: GlobalConfig.getSurveyId(),
            otherSetting:{
              enableRandomExtractionQuestion: val,
              randomExtractionQuestions:[]
            }
          }).then(res=> {
            if(res.data.code === 0){
              this.$message.success('随机抽题设置成功');
            }else{
              this.$message.error(res.data.msg);
            }
          })
          this.numFlag = false;

        }).catch(() => {
          this.numFlag = true;  
        });
      }else{
        if(!this.getLogicIsAllScreen()){
          this.$alert('您已设置题目逻辑,暂不支持同时开启随机抽题功能!', '无法设置', {
            confirmButtonText: '我知道了',
            callback: action => {}
          })
        }else if (this.quotaStatus){
          this.$alert('您已设置样本配额，暂不支持同时开启随机抽题功能！', '无法设置', {
            confirmButtonText: '我知道了',
            callback: action => {}
          })
        }else{
          this.numFlag = true;  
          this.randomExtractionQuestions = [{
            questionNumber:1,
            beginQuestionId:this.catchOptions.find((it,i)=>i===0).value,
            endQuestionId:'',
            beginIndex:0,
            endIndex: this.catchOptions.length - 1,
          }];
          this.optionsList = [{
            beginOptions: this.catchOptions,
            endOptions: this.catchOptions,
          }]

        }

      }
    },
    currentInputNumber(val){
      
    },
    handleSubmit(){
      saveSurveySetting({
        id: GlobalConfig.getSurveyId(),
        otherSetting:{
          enableRandomExtractionQuestion: this.numFlag,
          randomExtractionQuestions:this.randomExtractionQuestions
        }
      }).then(res=> {
        if(res.data.code === 0){
          this.$message.success('随机抽题设置成功');
        }else{
          this.$message.error(res.data.msg);
        }
      })
    },
    handleSettlement(type, index){
      if(type === 'add'){
        const {endQuestionId,endIndex} = this.randomExtractionQuestions[this.randomExtractionQuestions.length -1]
        if(!endQuestionId && !endIndex){
          this.$message.warning('请添加结束题目')
        }else if(endIndex === this.catchOptions.length -1){
          this.$message.warning('最后一题已加入抽题条件，无法继续添加')
        }else {
          const clonerandomExtractionQuestions = JSON.parse(JSON.stringify(this.randomExtractionQuestions));
          const cloneOptionsList = JSON.parse(JSON.stringify(this.optionsList));
          let beginIndex = clonerandomExtractionQuestions[clonerandomExtractionQuestions.length - 1].endIndex + 1;
          clonerandomExtractionQuestions.push({
            questionNumber:1,
            beginQuestionId:this.catchOptions.find((it,i)=>i===beginIndex).value,
            endQuestionId:'',
            beginIndex:beginIndex,
            endIndex: this.catchOptions.length -1,
          });
          let beginOptions =[];
          let endOptions =[];
          this.catchOptions.forEach((item,i)=> {
            let beginDisabled = false;
            let endDisabled = false;
            if( i < beginIndex || i > this.catchOptions.length -1 ){
              beginDisabled = true;
            }
            if( i < beginIndex ){
              endDisabled = true;
            }
            beginOptions.push({...item,disabled:beginDisabled});
            endOptions.push({...item,disabled:endDisabled})
          })
          cloneOptionsList.push({
            beginOptions: beginOptions,
            endOptions: endOptions,
          })
          this.randomExtractionQuestions = clonerandomExtractionQuestions;
          this.optionsList = cloneOptionsList;
        }
      }else if (type === 'remove'){
        const clonerandomExtractionQuestions = JSON.parse(JSON.stringify(this.randomExtractionQuestions));
        const cloneOptionsList = JSON.parse(JSON.stringify(this.optionsList));
        this.randomExtractionQuestions = clonerandomExtractionQuestions.filter((it,idx)=> idx !== index);
        this.optionsList = cloneOptionsList.filter((it,idx)=> idx !== index);
      }
    },
    changeBeginOptions(val,index){
      const findIndex = this.catchOptions.findIndex((it,i)=>it.value === val)
      const clonerandomExtractionQuestions = JSON.parse(JSON.stringify(this.randomExtractionQuestions));
      clonerandomExtractionQuestions.forEach((item,itemIdx)=>{
        if(index === itemIdx){
          item.beginIndex = findIndex;
          item.questionNumber = item.questionNumber > item.endIndex - item.beginIndex + 1 ? (item.endIndex - item.beginIndex) + 1 : item.questionNumber
        }
      })
      this.randomExtractionQuestions = clonerandomExtractionQuestions;
    },
    changeEndOptions(val,index){
      const findIndex = this.catchOptions.findIndex((it,i)=>it.value === val)
      const clonerandomExtractionQuestions = JSON.parse(JSON.stringify(this.randomExtractionQuestions));
      clonerandomExtractionQuestions.forEach((item,itemIdx)=>{
        if(index === itemIdx){
          item.endIndex = findIndex;
          item.questionNumber = item.questionNumber > item.endIndex - item.beginIndex + 1 ? item.endIndex - item.beginIndex + 1 : item.questionNumber
        }
      })
      this.randomExtractionQuestions = clonerandomExtractionQuestions;
    },
    getAllOptions(){
      return new Promise((resolve,reject)=>{
        getSurveyById(GlobalConfig.getSurveyId()).then(res => {
          if(res.data.code === 0){
            this.logics = res.data.data.logics;
            const filterQuestionType = [20,115,108]
            const filterName = res.data.data.pageQuestions.filter(it=> !filterQuestionType.includes(it.questionType) && it.type !== 4).map((it,i)=> ({label:`Q${i+1} ${it.content.text}`,value:it.id, type: typeMapping.get(it.questionType)}))
            this.catchOptions = filterName;
            resolve(filterName);
          }else{
            this.$message.error(res.data.msg);
          }
        })
      })
      
    },
    getInfo(resolveData){
      return getSurveyInfo(GlobalConfig.getSurveyId()).then(res=> {
        if(res.data.code === 0){
          const { otherSetting } = res.data.data;
          this.numFlag = otherSetting.enableRandomExtractionQuestion
          if(otherSetting.enableRandomExtractionQuestion === true && Array.isArray(otherSetting.randomExtractionQuestions) && otherSetting.randomExtractionQuestions.length > 0){
            let optionsList =[];
            otherSetting.randomExtractionQuestions.forEach(it=> {
              it.beginIndex = resolveData.findIndex((resIt)=>it.beginQuestionId === resIt.value);
              it.endIndex = resolveData.findIndex((resIt)=>it.endQuestionId === resIt.value);
              optionsList.push({
                beginOptions: resolveData,
                endOptions: resolveData,
              })
            })
            this.optionsList = optionsList;
            this.randomExtractionQuestions = otherSetting.randomExtractionQuestions;
          }else{
            const clonerandomExtractionQuestions = JSON.parse(JSON.stringify(this.randomExtractionQuestions));
            clonerandomExtractionQuestions.forEach((it,index)=> {
              if(index === 0){
                it.beginQuestionId = resolveData.find((it,i)=>i===0).value,
                it.beginIndex = 0;
                it.endIndex = resolveData.length - 1;
              }
            });
            this.optionsList = [{
              beginOptions:resolveData,
              endOptions:resolveData,
            }]
            this.randomExtractionQuestions = clonerandomExtractionQuestions;
          }
        }else{
          this.$message.error(res.data.msg);
        }
      })
    },
    // 获取是否存在样本配额
    getQuotaListStatus(){
      getQuotaList(GlobalConfig.getSurveyId())
      .then(({data})=> {
        if(data.code === 0){
          this.quotaStatus = data.data.some((it)=> it.conditionType!==1);
        }
      })
    }
  },
  created() {
    this.getAllOptions().then(res=> {
      this.getInfo(res);
    });
    this.getQuotaListStatus();
  },
  mounted(){
  },
  computed: {
    
  }
}
</script>
<style lang="scss" scoped>
::v-deep .random-question-items{
  .w-330{
    width: 360px;
    .el-input .el-input__inner{
      background: #fff;
      padding: 0 28px 0 12px;
    }
  }
}
  .random-setting{
    width: 100%;
    min-height:130px;
    background: #F5F5F5;
    border-radius: 2px;
    margin-top: 12px;
    padding: 12px 16px;
    box-sizing: border-box;
    .random-question-items{
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .w-330{
        width: 360px;
        .el-input{
          background: #fff;
        }
      }
      .ml-8{
        margin-left: 8px;
      }
      .btn-style{
        color:#A4B4CD;
        cursor: pointer;
      }
      span{
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: rgba(0,0,0,0.65);
        margin-left: 8px;
        margin-right: 8px;
      }
    }
    .tips-style{
      i{
        font-size: 12px;
        margin-right: 4px;
      }
      padding-left: 8px;
      margin-top: 4px;
      line-height: 22px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 12px;
      color: #E8A31B;
      display: flex;
      align-items: center;
    }
    .submit-btn{
      margin-top: 16px;
    }
  }
</style>
